import { TextField, Show, SimpleShowLayout } from "react-admin";

export const IsolatesDetailShow = (props) => (
  <Show
    {...props}
    /* disable the app title change when shown */
    title=" "
    hasEdit={false}
  >
    <SimpleShowLayout>
      <div>PHENOTYPE</div>
      <TextField source="isolates_phenotype.size" label="Size" />
      <TextField source="isolates_phenotype.shape" label="Shape" />
      <TextField source="isolates_phenotype.elevation" label="Elevation" />
      <TextField source="isolates_phenotype.border" label="Border" />
      <TextField source="isolates_phenotype.surface" label="Surface" />
      <TextField source="isolates_phenotype.color" label="Color" />
      <TextField
        source="isolates_phenotype.observation"
        label="Observation"
        multiline={true}
      />
    </SimpleShowLayout>
  </Show>
);
